/*
 * @Descripttion: 企业CRM信息
 * @Date: 2024-05-10 15:43:17
 */

import { route } from './src/router';

const name = 'company-crm';

export { name, route };
